import { MD3LightTheme, type MD3Theme } from 'react-native-paper';

const white = '#ffffff';

/** Green accent for labels, links, chips, and focus states */
export const brandPrimary = '#0F766E';
export const brandPrimarySoft = '#CCFBF1';

/** Filled buttons and active pill/toggle backgrounds */
export const brandButton = '#000000';

/**
 * Landing / marketing — logo-led palette (red / blue / yellow mark).
 * Use instead of brandPrimary on Landing so teal does not clash with the logo.
 */
export const landingAccent = '#2563EB';
export const landingLink = '#475569';
export const landingLabel = '#64748B';

/**
 * Light theme with true white page/surface backgrounds (Paper defaults use neutral99 / elevation tints).
 */
export const appPaperTheme: MD3Theme = {
  ...MD3LightTheme,
  colors: {
    ...MD3LightTheme.colors,
    background: white,
    surface: white,
    surfaceVariant: '#f3f4f6',
    elevation: {
      level0: 'transparent',
      level1: white,
      level2: white,
      level3: white,
      level4: white,
      level5: white,
    },
  },
};
